import { AnyAction } from 'redux'
import { IPricesAccepted } from '../../actions/price/pricesAccepted'
import { IPriceConfiguration } from '../../models/Price'
import { AuthorizationActions } from '../userAccount/actionNames'
import { PriceConfigurationActions, PriceGridAction } from './actionNames'
import initialState from './initialState'
import priceConfigurationAccepted from './mutators/priceConfigurationAccepted'
import togglePriceConfigurationLoading from './mutators/togglePriceConfigurationLoading'
import pricesHasBeenAccepted from './mutators/pricesHasBeenAccepted'
import openHint from './mutators/openHint'
import closeHint from './mutators/closeHint'
import toggleBlockHint from './mutators/toggleBlockHint'
import { PriceSettingsTab } from '../../containers/PriceSettingsContent/PriceSettingsNavigator'
import { xor } from 'lodash'
import { PriceEditModalActions } from '../priceEdit/actionNames'

export default function(
  store: Readonly<
    Partial<{
      prices: any
      config: IPriceConfiguration
      loading: boolean
      hint: IPriceHint
      startDate: Date
      finishDate: Date
      priceSettingsTab: PriceSettingsTab
      diff: boolean
      closeModal: boolean
      action: string
      configLoading: boolean
      errors: any
      expanded: any
      feeModal: any
      int: any
      editRoomOpen: boolean
      loadingGlobal: boolean
      roomSettings: any
      editRoomPrice: boolean
      roomSettingsGlobal: any
      priceGridFilter: any
      provisionPopout: boolean
      roomsExpanded: boolean
    }>
  > = initialState,
  action: AnyAction & IPricesAccepted,
) {
  switch (action.type) {
    case PriceConfigurationActions.PriceConfigurationAccepted:
      return priceConfigurationAccepted(store, action)
    case PriceConfigurationActions.SetDefaultConfig:
      return {
        ...store,
        config: {
          ...store.config,
          default: false,
        },
      }
    case PriceGridAction.SetDisplayed:
      return {
        ...store,
        config: {
          ...store.config,
          displayed: true,
        },
      }
    case PriceConfigurationActions.ToggleLoading:
      return togglePriceConfigurationLoading(store, action)
    case PriceGridAction.PricesAccepted:
      return pricesHasBeenAccepted(store, action)
    case AuthorizationActions.FlushState:
      return { ...initialState }
    case PriceGridAction.OpenHint:
      return openHint(store, action)
    case PriceGridAction.CloseHint:
      return closeHint(store, action)
    case PriceGridAction.ToggleBlockHint:
      return toggleBlockHint(store, action)
    case PriceGridAction.ChangeDates:
      return {
        ...store,
        finishDate: action.finishDate,
        startDate: action.startDate,
      }
    case PriceGridAction.ManualChangeDate:
      return {
        ...store,
        selectedDate: action.startDate,
      }
    case PriceGridAction.ExpandRooms:
      return {
        ...store,
        roomsExpanded: action.payload,
      }
    case PriceConfigurationActions.CloseOnBoardModal:
      return {
        ...store,
        onboardModal: false,
      }
    case PriceConfigurationActions.CloseOnBoardCalendarModal:
      return {
        ...store,
        onboardCalendarModal: false,
      }
    case PriceConfigurationActions.CloseOnBoardPriceModal:
      return {
        ...store,
        onboardPriceModal: false,
      }
    case PriceConfigurationActions.ChangePriceSettingsTab:
      return {
        ...store,
        priceSettingsTab: action.payload,
        errors: false,
      }
    case PriceConfigurationActions.SetDiff:
      return {
        ...store,
        diff: action.payload,
      }
    case PriceConfigurationActions.SetSettingsData:
      return {
        ...store,
        settingsData: action.payload,
      }
    case PriceConfigurationActions.SaveConfiguration:
      return {
        ...store,
        configLoading: true,
      }
    case PriceConfigurationActions.SetConfigurationLoading:
      return {
        ...store,
        configLoading: action.payload,
      }
    case PriceConfigurationActions.CloseModal:
      return {
        ...store,
        closeModal: action.payload,
        action:
          action.action !== undefined ? action.action : store.action,
      }
    case PriceConfigurationActions.SetErrorsSettings:
      return {
        ...store,
        errors: action.payload,
      }
    case PriceGridAction.SetScroll:
      return {
        ...store,
        scroll: action.payload,
      }
    case PriceGridAction.ExpandRow:
      return {
        ...store,
        expanded: xor(store.expanded, action.payload),
      }
    case PriceGridAction.ResetExpand:
      return {
        ...store,
        expanded: [],
      }
    case PriceConfigurationActions.OpenFeeModal:
      return {
        ...store,
        feeModal: action.payload,
      }
    case PriceGridAction.PricesNewAccepted:
      return {
        ...store,
        newPrices: action.prices,
        newPricesLoading: false,
      }
    case PriceGridAction.RequestNewPrices:
      return {
        ...store,
        newPricesLoading: !action.reload,
      }
    // case PriceGridAction.SetNewPricesLoading:
    //   return {
    //     ...store,
    //     newPricesLoading: action.payload
    //   }
    case PriceGridAction.OpenRoomEditModal:
      return {
        ...store,
        editRoomOpen: action.payload,
        editRoomId: action.roomId,
        airbnbSettingsErrors: {},
        bookingSettingsErrors: {},
        editRoomPrice: false,
        roomSettings: undefined,
        int: undefined,
      }
    case PriceEditModalActions.OpenPriceEditModal: {
      return {
        ...store,
        roomSettings: undefined,
      }
    }
    case PriceGridAction.OpenRoomEditModalOnly:
      return {
        ...store,
        editRoomOpen: action.payload,
        editRoomId: action.roomId,
        editRoomPrice: true,
        airbnbSettingsErrors: {},
        bookingSettingsErrors: {},
        int: action.int,
      }
    case PriceGridAction.PutRoomSettings:
      return {
        ...store,
        roomSettings: action.payload,
      }
    case PriceGridAction.PutRoomSettingsGlobal:
      return {
        ...store,
        roomSettingsGlobal: action.payload,
        loadingGlobal: false,
      }
    case PriceGridAction.LoadGlobalRoomSettings:
      return {
        ...store,
        loadingGlobal: true,
      }
    case PriceGridAction.SetProvisionPopoutState:
      return {
        ...store,
        provisionPopout: action.payload,
      }
    case PriceGridAction.ChangeAirbnbFieldSettings:
      return {
        ...store,
        roomSettings: {
          ...(store.roomSettings ? store.roomSettings : {}),
          integrations: {
            ...(store.roomSettings && store.roomSettings.integrations
              ? store.roomSettings.integrations
              : {}),
            airbnb: {
              ...(store.roomSettings &&
              store.roomSettings.integrations &&
              store.roomSettings.integrations.airbnb
                ? store.roomSettings.integrations.airbnb
                : {}),
              [action.field]: action.value,
            },
          },
        },
      }
    case PriceGridAction.ChangeBookingFieldSettings: {
      const currentList =
        store.roomSettings?.integrations?.booking ?? []
      const found = currentList.some(
        (b: any) => String(b.booking_id_pricing) === String(action.id)
      )
      const fields = (action.field || '').split('.')
      let newBooking: any[]
      if (found) {
        newBooking = currentList.map((booking: any) => {
          if (String(booking.booking_id_pricing) === String(action.id)) {
            let lastField: any = booking
            for (let i = 0; i < fields.length - 1; i++) {
              if (!lastField[fields[i]]) lastField[fields[i]] = {}
              lastField = lastField[fields[i]]
            }
            lastField[fields[fields.length - 1]] = action.value
            return booking
          }
          return booking
        })
      } else {
        const newEntry: any = { booking_id_pricing: action.id }
        if (fields.length === 1) {
          newEntry[action.field] = action.value
        } else {
          let obj = newEntry
          for (let i = 0; i < fields.length - 1; i++) {
            obj[fields[i]] = {}
            obj = obj[fields[i]]
          }
          obj[fields[fields.length - 1]] = action.value
        }
        newBooking = [...currentList, newEntry]
      }
      return {
        ...store,
        roomSettings: {
          ...(store.roomSettings ?? {}),
          integrations: {
            ...(store.roomSettings?.integrations ?? {}),
            booking: newBooking,
          },
        },
      }
    }
    case PriceGridAction.SetRoomSettingsAirbnbErrors:
      return {
        ...store,
        airbnbSettingsErrors: action.payload,
      }
    case PriceGridAction.SetRoomSettingsBookingErrors:
      return {
        ...store,
        bookingSettingsErrors: action.payload,
      }
    case PriceGridAction.SetPriceGridFilter:
      return {
        ...store,
        priceGridFilter: action.payload,
      }
    case PriceGridAction.CopyPricesConfirm:
      return {
        ...store,
        copyPricesFinished: false,
        copyPricesError: null,
      }
    case PriceGridAction.CopyPricesSuccess:
      return {
        ...store,
        copyPricesFinished: true,
        copyPricesError: null,
      }
    case PriceGridAction.CopyPricesFailure:
      return {
        ...store,
        copyPricesFinished: false,
        copyPricesError: (action as { error?: string }).error ?? null,
      }
    case PriceGridAction.CopyPricesReset:
      return {
        ...store,
        copyPricesFinished: false,
        copyPricesError: null,
      }
  }

  return store
}

export interface IPriceHint {
  anchorEl: React.MutableRefObject<HTMLDivElement>
  open: boolean
  block: boolean
  roomSize: number
  prices: any
  restrictions: any
  date: any
  extraBed: boolean
}
